import React from "react";

export const BillPaymentPendingIcon = () => {
  return (
    <>
      <svg
        width="81"
        height="80"
        viewBox="0 0 81 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="40.5"
          cy="40"
          r="40"
          fill="#FCB451"
          fillOpacity="0.1"
          style={{
            fill: "#FCB451",
            fill: "color(display-p3 0.9882 0.7059 0.3176)",
            fillOpacity: 0.1,
          }}
        />
        <g clipPath="url(#clip0_2034_52041)">
          <path
            d="M42.5081 23.646C42.3314 23.4781 42.1217 23.3489 41.8923 23.2667C41.6629 23.1844 41.4188 23.1509 41.1757 23.1683C40.9326 23.1856 40.6958 23.2535 40.4804 23.3675C40.265 23.4816 40.0758 23.6392 39.9248 23.8305C39.6829 24.1054 39.5283 24.446 39.4806 24.809C39.4329 25.172 39.4942 25.541 39.6569 25.8691C39.8195 26.1971 40.076 26.4693 40.3938 26.6511C40.7116 26.8329 41.0763 26.9161 41.4416 26.89C41.8068 26.8639 42.1559 26.7298 42.4447 26.5047C42.7334 26.2795 42.9487 25.9736 43.063 25.6258C43.1774 25.278 43.1857 24.904 43.0868 24.5514C42.988 24.1989 42.7866 23.8837 42.5081 23.646Z"
            fill="#FCB451"
            style={{
              fill: "#FCB451",
              fill: "color(display-p3 0.9882 0.7059 0.3176)",
              fillOpacity: 1,
            }}
          />
          <path
            d="M48.1358 26.3217C47.7818 26.7258 47.6024 27.2537 47.637 27.7899C47.6716 28.326 47.9173 28.8265 48.3203 29.1818C48.5143 29.4223 48.7583 29.6175 49.0355 29.7538C49.3127 29.8902 49.6163 29.9644 49.9251 29.9713C50.234 29.9781 50.5406 29.9174 50.8236 29.7935C51.1065 29.6696 51.359 29.4854 51.5634 29.2537C51.7678 29.0221 51.9191 28.7486 52.0068 28.4524C52.0946 28.1562 52.1166 27.8445 52.0713 27.5389C52.0261 27.2333 51.9147 26.9413 51.7449 26.6833C51.575 26.4252 51.3509 26.2073 51.0882 26.0449C50.8802 25.8604 50.6365 25.7206 50.3722 25.6342C50.108 25.5478 49.8288 25.5166 49.5519 25.5426C49.2751 25.5685 49.0066 25.6511 48.763 25.7851C48.5194 25.9191 48.3059 26.1017 48.1358 26.3217Z"
            fill="#FCB451"
            style={{
              fill: "#FCB451",
              fill: "color(display-p3 0.9882 0.7059 0.3176)",
              fillOpacity: 1,
            }}
          />
          <path
            d="M57.7305 36.286C58.0385 35.9082 58.2289 35.4483 58.278 34.9633C58.3272 34.4784 58.233 33.9896 58.0071 33.5577C57.7813 33.1257 57.4336 32.7695 57.0073 32.5332C56.5809 32.2969 56.0946 32.1909 55.6086 32.2283C55.1226 32.2657 54.6582 32.4448 54.273 32.7436C53.8879 33.0423 53.5988 33.4474 53.4416 33.9089C53.2845 34.3703 53.2661 34.8677 53.3889 35.3394C53.5117 35.8111 53.7701 36.2365 54.1323 36.5628C54.383 36.7887 54.677 36.9613 54.9965 37.0701C55.316 37.1789 55.6542 37.2216 55.9907 37.1958C56.3272 37.1699 56.6549 37.0759 56.954 36.9195C57.2531 36.7631 57.5173 36.5476 57.7305 36.286Z"
            fill="#FCB451"
            style={{
              fill: "#FCB451",
              fill: "color(display-p3 0.9882 0.7059 0.3176)",
              fillOpacity: 1,
            }}
          />
          <path
            d="M57.8232 44.0358C57.5124 43.7026 57.1346 43.4389 56.7146 43.262C56.2946 43.0852 55.8419 42.9993 55.3864 43.0099C54.9308 43.0205 54.4827 43.1274 54.0714 43.3236C53.6601 43.5198 53.2949 43.8008 53 44.1482C52.7051 44.4956 52.487 44.9014 52.3601 45.3391C52.2332 45.7767 52.2004 46.2363 52.2638 46.6876C52.3273 47.1388 52.4855 47.5715 52.728 47.9573C52.9706 48.343 53.2921 48.6731 53.6714 48.9257C54.3301 49.3645 55.1271 49.5461 55.911 49.4359C56.6948 49.3258 57.4109 48.9316 57.9232 48.3282C58.4355 47.7248 58.7083 46.9543 58.6899 46.163C58.6714 45.3717 58.363 44.6147 57.8232 44.0358Z"
            fill="#FCB451"
            style={{
              fill: "#FCB451",
              fill: "color(display-p3 0.9882 0.7059 0.3176)",
              fillOpacity: 1,
            }}
          />
          <path
            d="M43.1523 52.8008C42.6135 53.4237 42.2722 54.1927 42.1717 55.0102C42.0712 55.8276 42.216 56.6565 42.5879 57.3913C42.9597 58.1262 43.5417 58.7339 44.2599 59.1371C44.978 59.5403 45.7999 59.7208 46.6209 59.6556C47.4419 59.5904 48.225 59.2826 48.8705 58.7711C49.5161 58.2597 49.995 57.5679 50.2462 56.7835C50.4975 55.9992 50.5098 55.1579 50.2817 54.3665C50.0535 53.5752 49.5951 52.8696 48.9648 52.3395C48.5566 51.98 48.0804 51.7063 47.5643 51.5345C47.0483 51.3627 46.503 51.2964 45.9609 51.3394C45.4187 51.3824 44.8907 51.5339 44.4082 51.785C43.9258 52.036 43.4987 52.3815 43.1523 52.8008Z"
            fill="#FCB451"
            style={{
              fill: "#FCB451",
              fill: "color(display-p3 0.9882 0.7059 0.3176)",
              fillOpacity: 1,
            }}
          />
          <path
            d="M28.2064 50.2175C27.4143 51.1541 27.0192 52.363 27.1054 53.5866C27.1916 54.8102 27.7521 55.9518 28.6677 56.7681C29.3585 57.3601 30.209 57.7346 31.1121 57.8445C32.0153 57.9544 32.9307 57.7948 33.7434 57.3858C34.556 56.9767 35.2296 56.3365 35.6794 55.5457C36.1291 54.7549 36.335 53.8487 36.2711 52.9411C36.2072 52.0336 35.8763 51.1652 35.3202 50.4452C34.764 49.7252 34.0074 49.1857 33.1454 48.8946C32.2835 48.6035 31.3547 48.5738 30.4758 48.8092C29.597 49.0446 28.8074 49.5346 28.2064 50.2175Z"
            fill="#FCB451"
            style={{
              fill: "#FCB451",
              fill: "color(display-p3 0.9882 0.7059 0.3176)",
              fillOpacity: 1,
            }}
          />
          <path
            d="M26.2027 44.0766C29.0052 43.8524 31.0954 41.3988 30.8712 38.5962C30.647 35.7937 28.1933 33.7036 25.3908 33.9278C22.5883 34.152 20.4982 36.6056 20.7224 39.4081C20.9466 42.2107 23.4002 44.3008 26.2027 44.0766Z"
            fill="#FCB451"
            style={{
              fill: "#FCB451",
              fill: "color(display-p3 0.9882 0.7059 0.3176)",
              fillOpacity: 1,
            }}
          />
        </g>
        <defs>
          <clipPath id="clip0_2034_52041">
            <rect
              width="44.2857"
              height="44.2857"
              fill="white"
              style={{ fill: "white", fillOpacity: 1 }}
              transform="translate(19.0723 18.5715)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
